import React from 'react';
import { CondensedSmall, Flashy, Gutter, Icon, Layout } from '@axiom/ui';
import type { OpportunityCandidate } from '@axiom/validation';

import type { OpportunitySubmissionCandidateRateSchemaType } from './opportunity-submission-candidate-rate-schema';
import { OpportunitySubmissionCandidateRateUtil } from './opportunity-submission-candidate-rate-util';

export type OpportunitySubmissionCandidateRateCpqIndicatorProps = {
  opportunityCandidate: OpportunityCandidate;
  values: Partial<OpportunitySubmissionCandidateRateSchemaType>;
};

export const OpportunitySubmissionCandidateRateCpqIndicator = ({
  opportunityCandidate,
  values,
}: OpportunitySubmissionCandidateRateCpqIndicatorProps) => {
  const { marginApprovalCeiling, marginApprovalFloor } = opportunityCandidate;

  if (marginApprovalFloor === null || marginApprovalCeiling === null) {
    return null;
  }

  const { color, iconName, message, testId } =
    OpportunitySubmissionCandidateRateUtil.getCpqIndicator({
      formValues: values,
      marginApprovalFloor,
      marginApprovalCeiling,
    });

  return (
    <Layout position="middle">
      <Gutter right="8px">
        <Flashy color={color} name={testId}>
          <Icon name={iconName} />
        </Flashy>
      </Gutter>
      <CondensedSmall name="cpq-indicator-message">{message}</CondensedSmall>
    </Layout>
  );
};
